module.exports = __webpack_public_path__ + "static/chase_r.a384a6ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/reviews/chase_r.png
// module id = 1715
// module chunks = 35783957827783